import BasicContentTabs from './BasicContentTabs';

export { type BasicContentTabsProps } from './BasicContentTabs';
export default BasicContentTabs;
